import { render, staticRenderFns } from "./AccountsFormModal.vue?vue&type=template&id=08fd104a&scoped=true&"
import script from "./AccountsFormModal.vue?vue&type=script&lang=js&"
export * from "./AccountsFormModal.vue?vue&type=script&lang=js&"
import style0 from "./AccountsFormModal.vue?vue&type=style&index=0&id=08fd104a&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08fd104a",
  null
  
)

export default component.exports